import React, { FC, useMemo } from 'react'
import { cartMobx } from 'restaurant'
import { decorationMobx, eatTypeStatusMobx, storeMobx, timePickMobx } from '@mobxStore'
import { observer } from 'mobx-react'
import CashierController from '@ctrls/cashierController'
import './index.scss'

const EatTypeSwitchBar: FC = () => {
  const { eatTypeEntries } = decorationMobx
  const eatType = cartMobx.info.eatType
  const eatTypeArr = eatTypeEntries.map(item => item.value) as TEatType[]

  const isCanMobileBookingOrder = useMemo(() => {
    return !!(storeMobx.info.isMobileBookingOrder && timePickMobx.canPick)
  }, [storeMobx.info, timePickMobx])

  return eatTypeArr.length > 1 && (
    <div className='cart-tab'>
      <div className='eat-type-swicher'>
        {
          eatTypeArr.map((item) => {
            const isStoreInSale = Config.codeType === 'brand' ? (isCanMobileBookingOrder || storeMobx.info.inSale) : storeMobx.info.inSale
            let isDisable = isStoreInSale && eatTypeStatusMobx.hasEnableEatType && !eatTypeStatusMobx.isEatTypeEnable(item)
            if (Config.codeType === 'brand') {
              isDisable = isDisable && !isCanMobileBookingOrder
            }
            return (
              <div
                key={item}
                className={`eat-type-item${eatType === item ? ' active' : ''}`}
                data-cypid={`eatTypeSwitch_${item}`}
                onClick={() => {
                  if (item !== eatType && !isDisable) {
                    CashierController.switchEatType(item)
                  }
                }}
              >
                <div>{decorationMobx.eatTypeEntriesMap[item]?.name || i18n.t(`entry.${item}`)}</div>
                {
                  !!isDisable && <div>{i18n.t('store.eatTypeDisable')}</div>
                }
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default observer(EatTypeSwitchBar)
